export default __webpack_public_path__ + "static/media/weatherApp.a60b91e5.png";